<template>
    <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'manage-privilege-extra-payload'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
    >
        <b-form @submit.prevent="onSubmitModal" >
            <div class="row mb-1">
                <div class="col-12 p-0">
                    <div class="information-header">
                        {{ isEdit ? 'Edit Extra Payload/Config' :'Add Extra Payload/Config' }}
                    </div>
                </div>
            </div>
            <div class="modal-wrp mx-3">
                <div class="row mb-1">
                    <div class="col-12">
                        <b-form-group
                        :label="'Key Name*'"
                        label-class="font-medium-5"
                        >
                        <b-form-input
                        id="payload-key"
                        v-model="formData.key"
                        class="w-100"
                        placeholder="payload key"
                        required
                        :clearable="true"
                        :disabled="isEdit"
                        />
                        </b-form-group>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-12">
                        <b-form-group
                        :label="'Data Type*'"
                        label-class="font-medium-5"
                        >
                            <v-select
                            class="select-format-container font-medium-5 bg-dropdown"
                            v-model="formData.data_type"
                            :reduce="(option) => option.value"
                            :options="selDataTypeList"
                            required
                            :clearable="false"
                            :disabled="isEdit"
                            @input="option => onChangeDataType(option)"
                            >
                                <template #search="{attributes, events}">
                                <input
                                    class="vs__search"
                                    :required="!formData.data_type"
                                    v-bind="attributes"
                                    v-on="events"
                                />
                                </template>
                            </v-select>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mb-1">
                    <div class="col-12">
                        <b-form-group
                        :label=" formData.data_type != EXTRA_PAYLOAD_TYPE.DATETIME ? 'Value*' : ''"
                        label-class="font-medium-5"
                        >
                            <div v-if="formData.data_type == EXTRA_PAYLOAD_TYPE.BOOL">
                                <b-form-radio-group
                                    v-model="formData.value"
                                    :options="booleanTypeOptions"
                                    class="custom-radio-group"
                                />
                            </div>
                            <div v-else-if="formData.data_type == EXTRA_PAYLOAD_TYPE.DATETIME " class="d-flex" >
                                <b-row>
                                    <b-col cols="12" lg="10" sm="12">
                                        <label for="valid-from-date" class="font-medium-5">
                                        Date Time
                                        </label>
                                        <div class="col p-0 p-relative mr-2">
                                            <calendar-picker-icon
                                            class="icon-calendar bypass"
                                            :class="
                                                validFrom.date ? 'date-selected-icon' : null
                                            "
                                            />
                                            <flat-pickr
                                            :id="'valid-from-date'"
                                            v-model="validFrom.date"
                                            class="form-control  bg-date"
                                            :class="validFrom.date ? 'date-selected' : null"
                                            :config="flatpickrDateConfig"
                                            placeholder="-select-"
                                            autocomplete="off"
                                            @on-open="onOpenValidFromDatePicker"
                                            @on-change="onSelectValidFromDate"
                                            />
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col cols="12" lg="10" sm="12">
                                        <label for="valid-from-date" class="font-medium-5">
                                        Date Time
                                        </label>
                                        <div class="col p-0 p-relative">
                                            <clock-picker-icon
                                            class="icon-calendar date-picker-icon bypass"
                                            :class="
                                                validFrom.time ? 'date-selected-icon' : null
                                            "
                                            />
                                            <flat-pickr
                                            id="valid-from-time"
                                            v-model="validFrom.time"
                                            class="form-control  bg-date"
                                            :class="validFrom.time ? 'date-selected' : null"
                                            :config="flatpickrTimeConfig"
                                            :placeholder="'-select-'"
                                            autocomplete="off"
                                            @on-open="onOpenValidFromTimePicker"
                                            @on-change="onSelectValidFromTimePicker"
                                            />
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                            <div v-else>
                                <b-form-input
                                    id="payload-value"
                                    v-model="formData.value"
                                    @input="onNumberInput($event,'value',formData.data_type)"
                                    class="w-100"
                                    :placeholder="'ระบุ'"
                                    required
                                />
                                {{resolveExampleDataType(formData.data_type)}}
                            </div>

                        </b-form-group>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="modal-btn-wrp mt-2 mb-2">
                        <div class="d-flex justify-content-center">
                        <cancel-button
                            class="mr-1"
                            @click.native="$emit('onCloseModal')"
                        />
                        <save-button
                            class="ml-1"
                            type="submit"
                        />
                        </div>
                    </div>
                </div>
            </div>
        </b-form>
    </base-modal>
</template>

<script>
import BaseModal from '@/@core/components/base-modal/BaseModal.vue'
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import useManageExtraPayloadListModal from '../../hooks/useManageExtraPayloadListModal'

export default {
    components: { 
        BaseModal,
        CalendarPickerIcon,
        ClockPickerIcon,
        vSelect,
        flatPickr
    },
    props: {
        isEdit: { type: Boolean, default: false },
        formDataObj: { type: Object, default: {} },
    },
    setup(props) {
        const {
            fields,
            loading,
            formData,
            selDataTypeList,
            booleanTypeOptions,
            validFrom,
            flatpickrDateConfig,
            flatpickrTimeConfig,
            EXTRA_PAYLOAD_TYPE,
            onOpenValidFromDatePicker,
            onOpenValidFromTimePicker,
            onSelectValidFromDate,
            onSelectValidFromTimePicker,
            onChangeDataType,
            onSubmitModal,
            resolveExampleDataType,
            onNumberInput
        } = useManageExtraPayloadListModal(props)
        return {
            fields,
            loading,
            formData,
            selDataTypeList,
            booleanTypeOptions,
            flatPickr,
            validFrom,
            flatpickrDateConfig,
            flatpickrTimeConfig,
            EXTRA_PAYLOAD_TYPE,
            CalendarPickerIcon,
            ClockPickerIcon,
            onOpenValidFromDatePicker,
            onOpenValidFromTimePicker,
            onSelectValidFromDate,
            onSelectValidFromTimePicker,
            onChangeDataType,
            onSubmitModal,
            resolveExampleDataType,
            onNumberInput
        }
    },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style scoped>
@import "~@/assets/css/pages/data-management.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import '~@/assets/css/pages/privilege/privilege-extrapayload.css';
</style>